<template>
  <a-config-provider :locale="antdvLocale">
    <div v-if="!online">
      <h3>我没网了</h3>
      <div @click="refresh">刷新</div>
    </div>
    <router-view v-if="isRouteAlive" />
  </a-config-provider>
</template>

<script lang="ts">
import { defineComponent, computed, ref, nextTick } from 'vue';
import { mapState } from 'vuex';
import $ from 'jquery';

export default defineComponent({
  setup() {
    const online = computed(() => mapState(['online']));
    const isRouteAlive = ref(true);
    const refresh = () => {
      isRouteAlive.value = false;
      nextTick(() => (isRouteAlive.value = true));
    };
    return { online, isRouteAlive, refresh };
  },
  created() {
    $(document).on('mouseenter', '.j-might-overflow', e => {
      const $this: any = e.target;

      if (
        $this.offsetWidth < $this.scrollWidth &&
        !$this.getAttribute('title')
      ) {
        $this.setAttribute('title', $this.innerText);
        // const left = e.pageX,
        //   top = e.pageY;
        // const showEle = $('<div></div>', {
        //   text: $this.innerText,
        //   class: 'showTitleBox'
        // })
        //   .css({
        //     position: 'absolute',
        //     top: top + 10,
        //     left: left / 2,
        //     padding: '6px 8px',
        //     borderRadius: '4px',
        //     background: 'rgba(0,0,0,0.8)',
        //     zIndex: 1060,
        //     color: 'white'
        //   })
        //   .fadeIn(200);
        // showEle.appendTo('body');
      }
    });

    // 计算img scale
    window.addEventListener('resize', () => {
      this.$bus.$emit('calculate-img');
    });
  },
  computed: {
    ...mapState(['antdvLocale'])
  }
});
</script>

<style lang="less">
@import './theme.less';
</style>

<style lang="scss">
@import './index.scss';
</style>
